import React from 'react';
import { UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Icon from 'jsx/components/core/icons/Icon';
import { noop } from 'lodash';

const OtherBusinessMenu = ({ setDirectCostModal = noop, setBusinessIncomeModal = noop }) => {
  return (
    <div>
      <UncontrolledButtonDropdown>
        <DropdownToggle caret color="success" size="sm">
          <Icon name="plus" className="mr-1" />
          Action
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem toggle={true} onClick={() => setBusinessIncomeModal(true)}>
            Add Income
          </DropdownItem>

          <DropdownItem toggle={true} onClick={() => setDirectCostModal(true)}>
            Add Direct Cost
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
};

export default OtherBusinessMenu;
